import type { MenuProps } from '@bb/elements-web';
import { Button, DropdownButton, Flex } from '@bb/elements-web';
import type { AnnouncementType } from 'api/AnnouncementController';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { featureEnabled } from 'utils';

const getEditText = (type: AnnouncementItemActionsProps['type']): string => {
  switch (type) {
    case 'draft':
      return 'Continue Draft';
    case 'sent':
      return 'Re-use';
    case 'scheduled':
      return 'Cancel';
    default:
      return '';
  }
};

const items: MenuProps['items'] = [
  {
    key: '1-delete-announcement',
    label: <span data-cy="delete-announcement-menu-item">Delete</span>,
    danger: true,
  },
];

type AnnouncementItemActionsProps = {
  id: string;
  type: AnnouncementType;
  onOpenChange?: (open: boolean) => void;
  deleteAnnouncement: (
    id: string,
  ) => (event: React.MouseEvent) => Promise<void>;
};

const AnnouncementItemActions = ({
  id,
  type,
  onOpenChange,
  deleteAnnouncement,
}: AnnouncementItemActionsProps) => {
  const history = useHistory();

  const handleNavigate = () => {
    const link = `/announcement${type === 'draft' ? `/${id}/edit` : `/new?reuse=${id}`}`;
    history.push(link);
  };

  const handleMenuClick: MenuProps['onClick'] = e => {
    if (e.key === '1-delete-announcement') {
      deleteAnnouncement(id)(e.domEvent as React.MouseEvent);
    }
  };

  const editText = getEditText(type);

  const menu: MenuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <ActionContainer
      align="center"
      justify="center"
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
    >
      {type === 'scheduled' ? (
        <Button
          type="primary"
          color="danger"
          size="small"
          dataCy="delete-announcement-button"
          minWidth={10}
          onClick={deleteAnnouncement(id)}
        >
          {editText}
        </Button>
      ) : (
        <DropdownButton
          size="middle"
          type="secondary"
          menu={menu}
          onClick={handleNavigate}
          onOpenChange={onOpenChange}
          dataCy="announcement-item-dropdown"
          trigger={['click']}
        >
          {editText}
        </DropdownButton>
      )}
    </ActionContainer>
  );
};

const ActionContainer = styled(Flex)`
  flex: 1 0 25%;
  z-index: 5;
`;

export default AnnouncementItemActions;
